import { render } from "./NewsLanguage.vue?vue&type=template&id=2d004cb4&scoped=true"
const script = {}

import "./NewsLanguage.vue?vue&type=style&index=0&id=2d004cb4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d004cb4"]])

export default __exports__